import { useModule, videoVotingModuleQuery } from 'system/structure-modules';

export default function VideoVotingDebugScreen() {
    const { VideoVotingDemoScreen } = useModule(videoVotingModuleQuery);
    return <VideoVotingDemoScreen />;
}
